<template>
  <button
    :disabled="disabled || processing"
    class="btn"
    @click="handleClick"
  >
    <span
      v-if="screenReaderText"
      class="sr-only"
    >
      {{ screenReaderText }}
    </span>

    <span
      v-if="processing"
      class="flex items-center justify-start gap-1 relative"
    >
      <FontAwesomeIcon
        :icon="faSpinnerThird"
        spin
        class="text-xl"
      />

      <slot name="processing">
        <slot />
      </slot>
    </span>

    <template v-else>
      <slot />
    </template>
  </button>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';

const emit = defineEmits(['click']);

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  processing: {
    type: Boolean,
    default: false,
  },
  screenReaderText: {
    type: String,
    default: '',
  },
});

const handleClick = () => {
  if (!props.disabled) {
    emit('click');
  }
};

</script>
